import Color from 'color'

export type RGBColor = [ number, number, number ]

// input: #FFFFFF output [255, 255, 255]
export function hex2dec(hex: string): [ number, number, number ] {
  return [ parseInt(hex.substring(1, 3), 16), parseInt(hex.substring(3, 5), 16), parseInt(hex.substring(5, 7), 16) ]
}

export function rgb2hex([ r, g, b ]: RGBColor) {
  r = Math.round(r)
  g = Math.round(g)
  b = Math.round(b)
  r = Math.min(r, 255)
  g = Math.min(g, 255)
  b = Math.min(b, 255)
  return '#' + [ r, g, b ].map(c => c.toString(16).padStart(2, '0')).join('')
}

export function mixHexes(hex1: string, hex2: string, ratio: number = 0.5) {
  if (ratio > 1 || ratio < 0) {
    console.error(`Invalid ratio ${ ratio }`)
    return hex1
  }
  return mixRgb(hex2dec(hex1), hex2dec(hex2))
}

export const mixRgb = (color1: RGBColor, color2: RGBColor, ratio: number = 0.5): RGBColor => {
  const [ r1, g1, b1 ] = color1
  const [ r2, g2, b2 ] = color2
  const r = Math.round(r1 * ratio + r2 * (1 - ratio))
  const g = Math.round(g1 * ratio + g2 * (1 - ratio))
  const b = Math.round(b1 * ratio + b2 * (1 - ratio))
  return [ r, g, b ]
}

export const getRandomColorRgb = (baseColorHex: string, randomness: number): [ number, number, number ] => {
  const color = Color(baseColorHex)
  const rotated = color.rotate(360 * (Math.random() * randomness / 100))
  return [ rotated.red(), rotated.green(), rotated.blue() ]
}

export const colorEqual = ([ r1, g1, b1 ]: RGBColor, [ r2, g2, b2 ]: RGBColor) => r1 === r2 && g1 === g2 && b1 === b2

export const getColor = (colors: Float32Array, index: number): RGBColor => [ colors[index * 3], colors[index * 3 + 1], colors[index * 3 + 2] ]

export const setColor = (colors: Float32Array, index: number, [ r, g, b ]: RGBColor): void => {
  colors[index * 3] = r
  colors[index * 3 + 1] = g
  colors[index * 3 + 2] = b
}
